import ReactDOM from 'react-dom/client'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { initializeIcons } from '@fluentui/react'
import { StyledEngineProvider } from '@mui/material'

import AdminGuard from './components/AdminGuard'
import { GradientDefs } from './components/GradientDefs'
import MicroLearningGuard from './components/MicroLearningGuard'
import AccessRequestManagement from './pages/AccessRequestManagement/AccessRequestManagement'
import AdoptionDashboard from './pages/AdoptionDashboard/AdoptionDashboard'
import ApplicationAnalytics from './pages/ApplicationAnalytics/ApplicationAnalytics'
import Chat from './pages/chat/Chat'
import ExperimentRedirect from './pages/experiments/ExperimentRedirect'
import Experiments from './pages/experiments/Experiments'
import Home from './pages/home/Home'
import Layout from './pages/layout/Layout'
import MicroLearningDetail from './pages/MicroLearningDetail/MicroLearningDetail'
import MicroLearnings from './pages/MicroLearnings/MicroLearnings'
import NoPage from './pages/NoPage'
import ReleaseUpdates from './pages/ReleaseUpdates/ReleaseUpdates'
import SystemPrompts from './pages/SystemPrompts/SystemPrompts'
import UsersRolesAndPermissionsManagement from './pages/UsersRolesAndPermissionsManagement/UsersRolesAndPermissionsManagement'
import { AppStateProvider } from './state/AppProvider'

import './index.css'
initializeIcons()

export default function App() {
  return (
    <StyledEngineProvider injectFirst>
      <GradientDefs />
      <AppStateProvider>
        <HashRouter>
          <Routes>
            <Route
              path="/"
              element={<Home />}
            />
            <Route
              path="/app"
              element={<Layout />}>
              <Route
                index
                element={<Chat />}
              />
              <Route
                path="experiments"
                element={<Experiments />}
              />
              <Route
                path="experiments/:experimentCode"
                element={<ExperimentRedirect />}
              />
              <Route
                path="access-request-management"
                element={
                  <AdminGuard>
                    <AccessRequestManagement />
                  </AdminGuard>
                }
              />
              <Route
                path="users-roles-and-permissions-management"
                element={
                  <AdminGuard>
                    <UsersRolesAndPermissionsManagement />
                  </AdminGuard>
                }
              />
              <Route
                path="application-analytics"
                element={
                  <AdminGuard isOnlyAdminAllowed={true}>
                    <ApplicationAnalytics />
                  </AdminGuard>
                }
              />
              <Route
                path="adoption-dashboard"
                element={<AdoptionDashboard />}
              />
              <Route
                path="micro-learnings"
                element={
                  <MicroLearningGuard>
                    <MicroLearnings />
                  </MicroLearningGuard>
                }
              />
              <Route
                path="micro-learnings/:mlId"
                element={
                  <MicroLearningGuard>
                    <MicroLearningDetail />
                  </MicroLearningGuard>
                }
              />
              <Route
                path="system-prompts"
                element={
                  <AdminGuard isOnlyAdminAllowed={true}>
                    <SystemPrompts />
                  </AdminGuard>
                }
              />
              <Route
                path="release-updates"
                element={<ReleaseUpdates />}
              />
              <Route
                path="*"
                element={<NoPage />}
              />
            </Route>
          </Routes>
        </HashRouter>
      </AppStateProvider>
    </StyledEngineProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>
)
